const transpend=[
    {
        R019NE1:"0000123",
        R019SI1:"Cuenta de ahorro",
        R019NE2:"0000567",
        R019SI2:"Cuenta de ahorro",
        R019VAL:"150000",
        R019BNK:"Av villas",
        R019USU:"Usuario1",
        R019SUP:"Supervisor1",
        R019CUS:"12345"
    },
    {
        R019NE1:"0000456",
        R019SI1:"Cuenta de ahorro",
        R019NE2:"0000789",
        R019SI2:"Cuenta de ahorro",
        R019VAL:"200000",
        R019BNK:"Av villas",
        R019USU:"Usuario2",
        R019SUP:"Supervisor1",
        R019CUS:"67891"
    },
    {
        R019NE1:"0000101",
        R019SI1:"Cuenta de ahorro",
        R019NE2:"0000112",
        R019SI2:"Cuenta de ahorro",
        R019VAL:"250000",
        R019BNK:"Av villas",
        R019USU:"Usuario3",
        R019SUP:"Supervisor1",
        R019CUS:"11121"
    }
]

module.exports=transpend;